<template>
  <div
    class="form-input"
    :class="classObject"
  >
    <label
      :for="formID"
      class="form-input__label"
      :class="{ 'sr-only': hideLabel }"
    >
      <slot />
    </label>
    <span
      v-show="error"
      class="form-input__error"
    >{{ error }}</span>

    <select
      :id="formID"
      v-model="value"
      :name="name"
      class="form-input__input form-input__input--select"
      :required="required"
      :disabled="disabled"
    >
      <slot name="options" />
    </select>
  </div>
</template>

<script>
import formFieldsMixin from '../mixins/formFields'

export default {
  name: 'CFormSelect',

  mixins: [formFieldsMixin],

  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },

  props: {
    color: {
      type: String,
      default: undefined
    },
    disabled: Boolean,
    error: {
      type: String,
      default: undefined
    },
    hideLabel: Boolean,
    id: {
      type: [String, Number],
      default: undefined
    },
    inline: Boolean,
    inlineLabel: Boolean,
    name: {
      type: String,
      default: undefined
    },
    required: Boolean,
    modelValue: {
      type: undefined,
      default: undefined
    }
  },

  emits: ['update:modelValue'],

  computed: {
    value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>
